import Script from "next/script";
import type { FunctionComponent } from "react";

import { config } from "~/data";
import { getAssetPrefix } from "~/lib/utils";

export const PrebidScripts: FunctionComponent = () => (
  <Script
    id="prebid"
    src={`${getAssetPrefix()}/scripts/prebid.js`}
    strategy="lazyOnload"
    onLoad={() => {
      const trackName = "prebidTracker";

      ga("create", {
        allowLinker: true,
        cookieDomain: "auto",
        name: trackName,
        trackingId: config.advertisement.prebid.googleAnalyticsProfileId,
      });

      pbjs.que.push(() => {
        pbjs.setConfig({
          bidderTimeout: 5000,
          cache: { url: "https://prebid.adnxs.com/pbc/v1/cache" },
          rubicon: {
            collapse: false,
          },
        });
        pbjs.enableAnalytics([
          { options: { enableDistribution: false, trackerName: trackName }, provider: "ga" },
        ]);
      });
    }}
  />
);

PrebidScripts.displayName = "PrebidScripts";
